<template>
  <SortSearch default-sort="trending" dimension="TrendingDesigns" :force-experience="getMerch" />
</template>

<script>
import SortSearch from '@/components/SortSearch';
import { mapGetters } from 'vuex';

export default {
  components: {
    SortSearch
  },
  computed: {
    ...mapGetters('experience', ['getMerch'])
  },
  nuxtI18n: {
    paths: {
      en: '/merch/trending-designs/p/:page',
      es: '/merch/disenos-de-tendencia/p/:page',
      pt: '/merch/designs-de-tendencia/p/:page',
      de: '/merch/designs-im-trend/p/:page'
    }
  },
  head() {
    return {
      meta: [{ hid: 'robots', name: 'robots', content: 'noindex, follow' }]
    };
  }
};
</script>
